import { render, staticRenderFns } from "./locate.vue?vue&type=template&id=66c31e01&scoped=true"
import script from "./locate.vue?vue&type=script&lang=js"
export * from "./locate.vue?vue&type=script&lang=js"
import style0 from "./locate.vue?vue&type=style&index=0&id=66c31e01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c31e01",
  null
  
)

export default component.exports